import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { DeleteQueueRequest } from 'domain/usecases';
import { RemoteDeleteQueueRequest } from 'data/usecases';

export const makeRemoteDeleteQueueRequest = (requestId: string): DeleteQueueRequest => {
  return new RemoteDeleteQueueRequest(makeApiUrl(`/queue/requests/${requestId}`), makeAuthorizeHttpClientDecorator());
};
